import { rem } from "polished";
import styled, { css } from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  ColorLabels,
  getInvertedColor,
} from "@/components/editor/utils/use-color";

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  position: relative;

  .navigation-menu {
    background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  }

  .shadow-wrapper {
    &::before {
      background: linear-gradient(
        to right,
        ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]} 5%,
        ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]}03 30%
      );
    }
    &::after {
      right: 0;
      background: linear-gradient(
        to right,
        ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]}03 10%,
        ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]} 90%
      );
    }
  }

  .navigation-list-wrapper {
    background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};

    .navigation-button .navigation-icon {
      ${({ theme }) => css`
        --icon-color: ${getInvertedColor(theme.colors[ColorLabels.BACKGROUND])};
        background-color: var(--icon-color);
        &::before,
        &::after {
          background-color: var(--icon-color);
        }
      `}
    }

    .navigation-list {
      background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};

      > div div:not(:last-of-type) {
        &::after {
          color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
        }
      }

      a {
        color: ${({ theme }) =>
          theme.colors[ColorLabels.PRIMARY_FONT]} !important;
        font-family: ${({ theme }) =>
          theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
      }
    }
  }
`;

export const CTAButtonWrapper = withViewportStyle("div")`
  padding: 0 ${rem(24)} 0 ${rem(8)};
  white-space: nowrap;

  button {
    line-height: ${rem(28)};
    padding: ${rem(6)} ${rem(40)};
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
    border: ${rem(2)} solid ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};

    ${(props) => props.$viewport.mobile`
      font-size: ${rem(12)};
      padding-top: 0;
      padding-bottom: 0;
    `}
  }
`;
